import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async getSummary() {
        try {
            //My Attendance > Corrections main page
            const response = await axios.get(`AttendanceCorrections/summary`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })            
            return response
        }catch(error){
            console.log('attendancecorrections api getSummary error')
            throw error
        }
    },
    async getSummaryByTeam() {
        try {
            const response = await axios.get(`AttendanceCorrections/${store.state.selectedTeamId}/summary`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections_team_approver
                }
            })            
            return response
        }catch(error){
            console.log('attendancecorrections api getSummaryByTeam error')
            throw error
        }
    },
    async getSummaryByCompany() {
        try {
            const response = await axios.get(`AttendanceCorrections/0/summary`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections_company_approver
                }
            })            
            return response
        }catch(error){
            console.log('attendancecorrections api getSummaryByCompany error')
            throw error
        }
    },
    async getByCutoffByTeam(cutOffId) {
        try {    
            //My Team > Corrections main > By Cutoff           
            const response = await axios.get(`AttendanceCorrections/${store.state.selectedTeamId}/cutoff/${cutOffId}`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections_team_approver
                }
            })           
            return response
        }catch (error){
            throw error
        }
    },
    async getByCutoffByCompany(cutOffId) {
        try {    
            //My Team > Corrections main > By Cutoff           
            const response = await axios.get(`AttendanceCorrections/0/cutoff/${cutOffId}`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections_company_approver
                }
            })           
            return response
        }catch (error){
            throw error
        }
    },
    //used in Teams and Company attendance corrections
    async getByFYByTeam(fiscalYear) {
        try {           
            const response = await axios.get(`AttendanceCorrections/fy/${fiscalYear}/team/${store.state.selectedTeamId}`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections_team_approver
                }
            })           
            return response
        }catch (error){
            throw error
        }
    },  
    async getByTransDateByTeam(transDate) {
        try {          
            const response = await axios.get(`AttendanceCorrections/${store.state.selectedTeamId}/transdate/${transDate}`,
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections_team_approver
                }
            })                                    
            return response
        } catch (error) {
            console.log('AttendanceCorrections api getByTransDateByTeam error')
            throw error
        }
    },
    async getByCutoffByUser(cutOffId) {
        try{          
            //My Attendance > Corrections > By Cutoff     
            const response = await axios.get(`AttendanceCorrections/cutoff/${cutOffId}/user`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })                  
            return response
        }catch (error){
            throw error
        }
    },
    async getByFYByUser(fiscalYear) {
        try{          
            const response = await axios.get(`AttendanceCorrections/fy/${fiscalYear}/user`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })                  
            return response
        }catch (error){
            throw error
        }
    },
    async getById(attendanceCorrectionsId, pageKey) {
        try{               
            const response = await axios.get(`AttendanceCorrections/${attendanceCorrectionsId}`, {
                headers: {
                    'page_key': pageKey
                }
            })                        
            return response
        }catch (error){
            throw error
        }
    },
    async add(data) {
        try{            
            const response = await axios.post(`AttendanceCorrections/add`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })  
            return response
        }catch (error){
            throw error
        }
    },
    async addFromMyTeams(data, teamId, pageKey) {
        try{            
            const response = await axios.post(`AttendanceCorrections/add/${teamId}`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })  
            return response
        }catch (error){
            throw error
        }
    },
    async update(data) {
        try{            
            const response = await axios.post(`AttendanceCorrections/update`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })  
            return response
        }catch (error){
            throw error
        }
    },
    async forReview(data) {
        try{            
            const response = await axios.post(`AttendanceCorrections/forreview`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })  
            return response
        }catch (error){
            throw error
        }
    },
    async approve(data, pageKey) {
        try{              
            const response = await axios.post(`AttendanceCorrections/${store.state.selectedTeamId}/approve`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })              
            return response
        }catch (error){
            throw error
        }
    },
    async reject(data, pageKey) {
        try{               
            const response = await axios.post(`AttendanceCorrections/${store.state.selectedTeamId}/reject`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })       
            return response
        }catch (error){
            throw error
        }
    },
    async delete(data) {
        try{               
            const response = await axios.post(`AttendanceCorrections/delete`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })      
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getByUser(transDate) {
        try{              
            const response = await axios.get(`AttendanceCorrections/byuser/${transDate}`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })                                    
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getMonthlyByUser(month) {
        try{               
            const response = await axios.get(`AttendanceCorrections/byuser/monthly/${month}`, {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })                                    
            return response
        }catch (error){
            throw error
        }
    },
    async getAttachmentUrl(userId, fileName) {
        try
        {            
            const response = await axios.post(`AttendanceCorrections/attachment/pre-signed-url`,
            {
                userId: userId,
                fileName: fileName
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('AttendanceCorrections getAttachmentUrl api error')
            throw error
        }
    },
    async saveAttachment(data) {
        try
        {            
            const response = await axios.post(`AttendanceCorrections/attachment/save`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('AttendanceCorrections saveAttachment api error')
            throw error
        }
    },
    async deleteAttachment(attendanceCorrectionsAttachmentId) {
        try
        {            
            const response = await axios.post(`AttendanceCorrections/attachment/delete/${attendanceCorrectionsAttachmentId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.attendance_corrections
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('AttendanceCorrections deleteAttachment api error')
            throw error
        }
    },
}